import React from 'react';
import AdminReportTemplate from '@components/admin/admin-report-template';
import AdminRisks from '@pages/admin/admin-risks/admin-risks';
import EventLog from '../../views/pages/admin/event-log';
import Features from '../features';
import { IRoute } from './interfaces';
import { mergeArrays } from '@utils-clean/array-helpers';
import { UserLevel } from 'types/graphql-global-types';
import Constants from 'utils/constants';
import AdminPlugin from 'views/components/admin/admin-plugin';
import AdminSnapshot from 'views/components/admin/snapshots/admin-snapshot';
import AdminOrganisationPlugin from 'views/pages/admin/organisations/admin-organisation-plugin';
import AdminOrganisations from 'views/pages/admin/organisations/manage-organization/admin-organisations';
import AdminStudyPlugin from 'views/pages/admin/study/admin-study-plugin';
import AdminUsers from 'views/pages/admin/users/admin-users';
import { AdminPaths } from '@config/routes/paths';

const location = {
    state: {
        layout: 'PRIVATE',
    },
};

// IMPORTANT - For any new routes, the key and path must be added to paths.tsx and the path prop should be excluded from this file

const AdminRoutes: IRoute[] = mergeArrays(
    AdminPaths,
    [
        {
            key: 'admin-organisations',
            component: AdminOrganisations,
            exclude: [Constants.SystemAdminLevel.Contributor],
            breadcrumbs: ['uam:admin', 'uam:organisations'],
            location,
        },
        {
            key: 'admin-user-accounts',
            component: AdminUsers,
            exclude: [Constants.SystemAdminLevel.Contributor],
            breadcrumbs: ['uam:admin', 'uam:users'],
            feature: Features.AdminUsers,
            location,
        },
        {
            key: 'admin-event-log',
            exclude: [Constants.SystemAdminLevel.Contributor],
            componentFn: () => <EventLog userLevel={UserLevel.SYSTEM} />,
            location,
        },
        {
            key: 'admin-risks',
            exclude: [Constants.SystemAdminLevel.Contributor],
            breadcrumbs: ['uam:admin', 'ra:risks'],
            component: AdminRisks,
            feature: Features.AdminRisks,
            location,
        },
        {
            key: 'admin-organisation-plugin',
            include: [Constants.SystemAdminLevel.Administrator, Constants.SystemAdminLevel.SysAdmin],
            component: AdminOrganisationPlugin,
            location,
        },
        {
            key: 'admin-study-plugin',
            component: AdminStudyPlugin,
            include: [Constants.SystemAdminLevel.Administrator, Constants.SystemAdminLevel.SysAdmin],
            location,
        },
        {
            key: 'admin-system-plugin',
            include: [Constants.SystemAdminLevel.Administrator, Constants.SystemAdminLevel.SysAdmin],
            componentFn: () => <AdminPlugin />,
            location,
        },
        {
            key: 'admin-manage-report-templates',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminReportTemplate,
            location,
        },
        {
            key: 'admin-system-snapshot',
            include: [Constants.SystemAdminLevel.SysAdmin],
            componentFn: () => <AdminSnapshot />,
            location,
        },
    ],
    (item) => item.key,
);

export default AdminRoutes;
